export default __webpack_public_path__ + "static/media/netsuite.d44b1625.svg";